export default __webpack_public_path__ + "static/media/Icon_User.ecf6eb43.svg";